import { gql } from '@apollo/client';

export const FeatureQuery = gql`
  query GetFeatureToggles {
    featureToggles {
      pauseStoreEnabled
      availabilityByVariantEnabled
      surchargeEnabled
      operatingHoursEnabled
      boostEnabled
      snoozeEnabled
      menuManagerToConnectRedirectionEnabled
    }
  }
`;
